// extracted by mini-css-extract-plugin
module.exports = {"loungeLogo":"Logo_loungeLogo__3ksDO","loungeLogo__large":"Logo_loungeLogo__large__2omsC","loungeLogo__full":"Logo_loungeLogo__full__3GXuz"};